// extracted by mini-css-extract-plugin
module.exports = {"dots":"style_dots__UtSRT","dots-item":"style_dots-item__73WvO","active":"style_active__yLbdh"};